import { makeStyles } from "@mui/styles";


const useStyles = makeStyles((theme) => {

    const desktop = theme.breakpoints.up("lg");
    const mobile = theme.breakpoints.down("lg");

    const obj = {
        root: {
            display: 'flex',
            [mobile]: {
                flexDirection: 'column'
            },
            [desktop]: {
                flexDirection: 'row',
            },
        },
        content: {
            flex: '1',            
        },
        mainContent: {
            [desktop]: {
                height: 150,                
            }
        },
        cover: {
            [desktop]: {
                width: 150,
                height: 150
            },
            [mobile]: {
                margin: "0 auto",
                marginTop: theme.spacing() 
            }
        },
        actions: {
            [desktop]: {
                width: 180,
            },            
            [mobile]: {       
                margin: "0 auto"
                
            }
        },
        mobileimg: {
            [mobile]: {       
                width: 150,
                height: 150,
                
            }
        },
        centered: {
            textAlign: 'center'
        },
        textRight: {
            textAlign: 'right'
        },
        price: {
            fontWeight: "bold",
            color: theme.palette.primary.main,
        },
        pricesubtitle: {
            color: theme.palette.grey[500],
            fontWeight: "bold",
        },
        addinfoicon: {
            color: theme.palette.grey[500],
        },
        nonclickable: {
            cursor: "default",
            padding: 0,
        },
        addinfobtnicon: {
            color: theme.palette.primary.main,
        },
    }

    return obj;
})

export default useStyles;